import { NextSeo } from 'next-seo';
import * as React from 'react';

import { Video } from '@/lib/videos';

import FAQSection from '@/components/landing/FAQSection';
import FeaturesSection, { Feature } from '@/components/landing/FeaturesSection';
import GetStartedSection from '@/components/landing/GetStartedSection';
import HeroSection from '@/components/landing/HeroSection';
import TestimonialsSection from '@/components/landing/TestimonialsSection';
import Layout from '@/components/layout/Layout';

const title = `AI-Powered Video Repurposing Software`;
const ForMarketersPage: React.FC<{ videos: Video[] }> = ({ videos }) => {
  return (
    <>
      <NextSeo title={title} />
      <Layout mode='light'>
        <main>
          <HeroSection
            pageType='For Marketers'
            titleTop='Repurpose videos into short-form clips'
            titleBottom=''
            subtitle='We use AI to automatically turn your videos into short form clips to help you reach new demographics in new ways.'
          />
          {/*<DemoVideoSection />*/}
          <FeaturesSection>
            <Feature
              name='Easy marketing content'
              description='Instantly turn your existing videos into fresh marketing content for social media.'
              image='/images/easy-marketing-2.png'
              alt='Hero image'
            />
            <Feature
              name='Increased engagement'
              description='We look for catchy moments within your videos that are likely to get high engagement.'
              image='/images/increased-engagement-2.png'
              alt='Hero image'
              flipped
            />
            <Feature
              name='Reuse existing content'
              description='Repackage your existing videos instead of always needing to come up with new ideas.'
              image='/images/reuse-content.png'
              alt='Hero image'
            />
            <Feature
              name='Cut production costs'
              description='Pay less than 10x the price of what it costs to hire an editor.'
              image='/images/lower-price-5.png'
              alt='Hero image'
              flipped
            />
          </FeaturesSection>
          <TestimonialsSection />
          <FAQSection />
          <GetStartedSection />
        </main>
      </Layout>
    </>
  );
};

export default ForMarketersPage;
